import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Snippet } from "@nextui-org/react";

import Input from "@/components/input/Input";
import Button from "@/components/Button";
import { ExportToExcel } from "@/components/ExportToExcel";

import { useCreateLectureVouchers } from "../hooks/useCreateLectureVouchers";

function CreateForm() {
    const { courseId, lectureId } = useParams();
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();
    const {
        createVouchers,
        isCreating,
        error: ApiError,
        vouchers,
    } = useCreateLectureVouchers();

    function onSubmit(data) {
        createVouchers(
            { ...data, courseId, lectureId },
            {
                onSuccess: () => {
                    reset();
                },
            }
        );
    }

    const vouchersConverted = vouchers?.map((code) => ({ الاكواد: code }));

    return (
        <>
            <div className="flex flex-col items-center justify-center pt-5 transition-all duration-300">
                {/* Export Codes To Excel File */}

                <form
                    onSubmit={handleSubmit(onSubmit)}
                    className="flex flex-col pt-16 gap-7 lg:w-[50%] mx-auto"
                >
                    <Input
                        type="number"
                        size="fullWidth"
                        disabled={isCreating}
                        label="عدد الأكواد المطلوبة"
                        register={register("amount", {
                            required:
                                "يجب أدخال عدد الأكواد المطلوبة ولا يقل عن 1",
                            min: {
                                value: 1,
                                message: "برجاء إدخال رقم لا يقل عن 1",
                            },
                            valueAsNumber: true,
                        })}
                        error={
                            errors?.amount?.message ||
                            ApiError?.response?.data?.errors?.amount?.[0]
                        }
                    />
                    <Button type={"primary"} disabled={isCreating}>
                        إنشاء
                    </Button>
                </form>
                <div className="py-8">
                    {vouchers?.length && (
                        <ExportToExcel
                            className={`${
                                vouchers?.length ? "opacity-100" : "opacity-0"
                            } `}
                            apiData={vouchersConverted}
                            fileName={"اكواد المحاضره"}
                        />
                    )}
                </div>
            </div>

            {vouchers?.length && (
                <div className="flex flex-col items-center justify-center gap-8">
                    <ul
                        id="vouchers-list"
                        className="flex flex-row flex-wrap items-center justify-center gap-10 pt-20 mx-auto list-disc w-fit "
                    >
                        {vouchers.map((voucher) => (
                            <Snippet
                                variant="bordered"
                                symbol=""
                                className="bg-white"
                                key={voucher}
                            >
                                <h4 className="text-lg font-semibold text-blue-color-primary">
                                    {voucher}
                                </h4>
                            </Snippet>
                        ))}
                    </ul>
                </div>
            )}
        </>
    );
}

export default CreateForm;
